import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SharedModule } from '../shared.module';
import { catchError, map } from 'rxjs/operators';

//SERVICES
import { ConfigService } from '../services/config.service';
//MODELS
//import { Cart } from '../models/cart.interface';
import { Observable, of, Subscriber, throwError } from 'rxjs';
import { CompassApiResponse } from '../models/compass-api-response.interface';
import { CompassApiStatusEnum } from '../models/compass-api-status-enum';
import { Cart } from '../models/cart.interface';
import { CompassApiGetResults } from '../models/compass-api-get-results.interface';
import { CartTest } from '../models/cart-test.interface';
import { CartItem } from '../models/cart-item.interface';


@Injectable({providedIn: SharedModule})
export class CompassAPICartService {

	public params = new URLSearchParams();
	public config: any;
	public baseUrl: string;

	constructor(
		private httpClient: HttpClient,
		private _configService: ConfigService
	) {

		this.config = this._configService.getCompassApi();
		//console.log('this.config:', this.config);
		this.baseUrl = this.config.baseUrl + 'carts';
	}

	/**
	 * Get Carts
	 * @param limit
	 * @param offset
	 * @returns
	*/
	public getCarts (limit: number = null, offset: number = null){
		let url = new URL(this.baseUrl);
		if(limit) url.searchParams.append('limit', String(limit));// Todo: Call .toString()
		if(offset) url.searchParams.append('offset', String(offset));
		//('API.getCarts().url', String(url));

		return this.httpClient
			.get(String(url), { headers: this.config.headers })
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.getCarts.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					const results: Cart[] = res.results;
					const getResults: CompassApiGetResults = {
						total: res.total,
						results: results
					}
					return getResults;
				} else {
					return null;
				}
			}));
	}

	public getCart(id){
		let url = this.baseUrl + "/" + id,
			options = {headers: this.config.headers};

		return this.httpClient.get(url, options).pipe(
				catchError(err => of({"error": err}))
			)
			.pipe(map((res: CompassApiResponse) => {
				console.log(res)
				if(res.status == CompassApiStatusEnum.ok){
					return res.result;
				} else {
					return res;
				}
			}))
	}

  public cartTest () : Observable<CartTest>{
		let url = new URL(this.baseUrl+"/test");
		//('API.getCarts().url', String(url));
    let error = null;

    return this.httpClient
    .get(String(url), {headers: this.config.headers})
    .pipe(map((res: CompassApiResponse) => {
      return res.results;
    }), catchError(err =>
      {
        console.log('an error occured ************************************************', err);
        error = err;
        return err;
      }
    ));
      var flag = true;
	}


	/**
	 * Post (create) Cart
	 * @param data:Cart
	 * @returns
	*/
	public postCart (data: Cart): Observable<Cart[]>{
		let url = this.baseUrl,
			body = data,
			options = {
				headers: this.config.headers,
			};
		//console.log('API.postCart().url', url);
		//console.log('API.postCart().body', body);
		//console.log('API.postCart().options', options);

		let response = this.httpClient
		.post(url, body, options)
		.pipe(
		// catchError(err => of({"error": err}))
		catchError((error:any) => {
			console.log("Issues? " +  error);
			return 'something went wrong in post cart';
		})
		)
		.pipe(map((res: CompassApiResponse) => {
		//console.log('API.postCart.res:', res);
		if(res.status == CompassApiStatusEnum.ok) {
			return res.result;
		} else {
			return res;//uses error
		}
		}));
		return response;
	}


	/**
	 * Put (create) Cart
	 * @param data:Cart
	 * @returns
	*/
	public putCart (data: Cart){
		let url = this.baseUrl + '/' + data.id,
			body = data,
			options = {
				headers: this.config.headers,
			};
		//console.log('API.putCart().url', url);
		//console.log('API.putCart().body', body);
		//console.log('API.putCart().options', options);

		return this.httpClient
			.put(url, body, options)
			.pipe(
				catchError(err => of({"error": err}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.putCart.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else {
					return res;//uses error
				}
			}));
	}

	public postCartItem(data: CartItem){
		let url = this.baseUrl + '/UpdateItem',
		body = {
			id: data.id,
			item: data
		},
		options = {headers: this.config.headers};
		//console.log(body)
		return this.httpClient
			.post(url, body, options)
			.pipe ( catchError(err => of({"error": err})))	
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.putCart.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else {
					return res;//uses error
				}
			}));		
	}

	public putCartItem(data: CartItem){
		let url = this.baseUrl + "/AddItem",
		body = {
			item: data
		},
		options = {headers: this.config.headers};
		//console.log(body)
		return this.httpClient.put(url, body, options)
			.pipe(
				catchError(err => of({"error": err}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.putCart.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else {
					return res;//uses error
				}
			}));
	}

	public deleteCartItem (data: CartItem){
		let url = this.baseUrl + "/DeleteItem",
					body = {
						id: data.id,
						item: data
					},
					options = {
						headers: this.config.headers
					};
		return this.httpClient.post(url, body, options).pipe(
			catchError(err => of({"error": err}))
		)
		.pipe(map((res: CompassApiResponse) => {
			//console.log('API.putCart.res:', res);
			if(res.status == CompassApiStatusEnum.ok) {
				return res.result;
			} else {
				return res;//uses error
			}
		}));
	}
	public loadCustomerCart(){
		let url = this.baseUrl + "/GetCart",
			options = {headers: this.config.headers};

			return this.httpClient.get(url, options).pipe(
				catchError(err => of({"error": err}))
			)
			.pipe(map((res: CompassApiResponse) => {
				console.log(res)
				if(res.status == CompassApiStatusEnum.ok){
					return res.result;
				} else {
					return res;
				}
			}))
	}
	/**
	 * Delete Cart
	 * @param id: cartID
	 * @returns
	*/
	public deleteCart (id: string){
		let url = this.baseUrl + '/' + id,
			options = {
				headers: this.config.headers,
			};
		//console.log('API.deleteCart().url', url);
		////console.log('API.deleteCart().options', options);

		return this.httpClient
			.delete(url, options)
			.pipe(
				catchError(err => of({"error": err}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.deleteCart.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else {
					return res;//uses error
				}
			}));
	}



}
